import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IssueChatUnreadWsStateService {

  private countByVehicleSource = new BehaviorSubject<Map<number, number>>(null);
  public countByVehicle$ = this.countByVehicleSource.asObservable();

  public notifyCountByVehicle(countByVehicle: Map<number, number>) {
    this.countByVehicleSource.next(countByVehicle);
  }
}
